import Editor from './editor';

const cat = {
  Editor,
};
export default cat;
